import * as XLSX from "xlsx-js-style";
import { saveAs } from "file-saver";

export const exportPrize = (data) => {
  if (!data || data.length === 0) {
    alert("Tidak ada data untuk diexport.");
    return;
  }

  const today = new Date().toLocaleDateString("id-ID");

  const headerTitle = ["LAPORAN DATA PRIZE / HADIAH"];
  const headerDate = [`Tanggal Export: ${today}`];

  const headers = [
    "No",
    "Nama Hadiah",
    "Deskripsi",
    "Stock",
    "Harga",
    "Probability (%)",
    "Status",
  ];

  const rows = data.map((item, index) => [
    index + 1,
    item.name,
    item.description || "-",
    item.stock,
    Number(item.price || 0),
    Number(item.probability || 0),
    item.is_active === true || item.is_active === "true"
      ? "Aktif"
      : "Nonaktif",
  ]);

  const worksheetData = [headerTitle, headerDate, headers, ...rows];

  const ws = XLSX.utils.aoa_to_sheet(worksheetData);

  // MERGE TITLE
  ws["!merges"] = [
    { s: { r: 0, c: 0 }, e: { r: 0, c: headers.length - 1 } },
    { s: { r: 1, c: 0 }, e: { r: 1, c: headers.length - 1 } },
  ];

  // TITLE STYLE
  ws["A1"].s = {
    font: { bold: true, sz: 16, color: { rgb: "FFFFFF" } },
    alignment: { horizontal: "center", vertical: "center" },
    fill: { fgColor: { rgb: "1677FF" } },
  };

  // SUBTITLE
  ws["A2"].s = {
    font: { italic: true, sz: 12 },
    alignment: { horizontal: "center" },
  };

  // HEADER STYLE
  headers.forEach((_, idx) => {
    const col = String.fromCharCode(65 + idx);
    const cell = ws[`${col}3`];

    if (cell) {
      cell.s = {
        font: { bold: true, color: { rgb: "FFFFFF" } },
        fill: { fgColor: { rgb: "52C41A" } },
        alignment: { horizontal: "center", vertical: "center" },
        border: {
          top: { style: "thin" },
          bottom: { style: "thin" },
          left: { style: "thin" },
          right: { style: "thin" },
        },
      };
    }
  });

  // DATA STYLE
  rows.forEach((row, rIdx) => {
    row.forEach((_, cIdx) => {
      const col = String.fromCharCode(65 + cIdx);
      const cell = ws[`${col}${rIdx + 4}`];

      if (cell) {
        cell.s = {
          alignment: {
            vertical: "center",
            horizontal: cIdx === 0 ? "center" : "left",
            wrapText: true,
          },
          border: {
            top: { style: "thin" },
            bottom: { style: "thin" },
            left: { style: "thin" },
            right: { style: "thin" },
          },
        };

        // Highlight probability tinggi
        if (cIdx === 5 && Number(cell.v) > 50) {
          cell.s.fill = { fgColor: { rgb: "FFF1F0" } };
          cell.s.font = { color: { rgb: "CF1322" }, bold: true };
        }

        // Status warna
        if (cIdx === 6) {
          if (cell.v === "Aktif") {
            cell.s.fill = { fgColor: { rgb: "F6FFED" } };
          } else {
            cell.s.fill = { fgColor: { rgb: "FFF1F0" } };
          }
        }
      }
    });
  });

  // WIDTH
  ws["!cols"] = [
    { wch: 6 },
    { wch: 30 },
    { wch: 45 },
    { wch: 10 },
    { wch: 18 },
    { wch: 18 },
    { wch: 15 },
  ];

  // FOOTER
  const totalProbability = data.reduce(
    (sum, item) => sum + Number(item.probability || 0),
    0
  );

  const footerStartRow = rows.length + 5;

  ws[`E${footerStartRow}`] = { v: "Total Probability" };
  ws[`F${footerStartRow}`] = { v: totalProbability };

  ws[`E${footerStartRow + 1}`] = { v: "Sisa Probability" };
  ws[`F${footerStartRow + 1}`] = { v: 100 - totalProbability };

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Prize Report");

  const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });

  saveAs(
    new Blob([wbout], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    }),
    `Laporan_Prize_${today}.xlsx`
  );
};
